import React from 'react';

const Education = () => {
    return (
        <div className="flex justify-center items-center pt-8 ">
            <div className="text-center">
                <h1 className="text-3xl font-bold mb-4 text-gray-400">Education</h1>
                <h1 className="text-2xl font-bold mb-4 text-slate-400">Barkatullah University Institute of Technology</h1>
                <h1 className="text-xl text-gray-500 mb-2">Bachelor of Technology | Information Technology</h1>
                <p className=" text-gray-500 text-md">
                    Barkatullah University Institute of Technology is a public engineering college located in Bhopal. <br />
                    It is one of the 15 government engineering colleges in Madhya Pradesh.
                </p>
            </div>
        </div>
    );
};

export default Education;
